exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "button.print-button{color:#fff;background-color:#337321}", ""]);
